/**
 * Which control answers the question on screen.
 *
 * A lookup rather than a chain of ternaries, because nine of those is where a step
 * quietly starts rendering the wrong screen.
 *
 * A step with no entry renders the placeholder below. That is deliberate: it is visible
 * in the browser and impossible to mistake for finished work, where a blank div looks
 * exactly like a step that is done. Entries are added as each step is built.
 */
import { STEP } from '../../utils/steps'
import ServiceStep from './steps/ServiceStep'
import PickupStep from './steps/PickupStep'
import PickupContactStep from './steps/PickupContactStep'
import DropoffStep from './steps/DropoffStep'
import ItemsStep from './steps/ItemsStep'
import BudgetStep from './steps/BudgetStep'
import TimingStep from './steps/TimingStep'
import PaymentStep from './steps/PaymentStep'
import SummaryStep from './steps/SummaryStep'

const BODIES = {
  [STEP.SERVICE]: ServiceStep,
  [STEP.PICKUP]: PickupStep,
  [STEP.PICKUP_CONTACT]: PickupContactStep,
  [STEP.DROPOFF]: DropoffStep,
  [STEP.ITEMS]: ItemsStep,
  [STEP.BUDGET]: BudgetStep,
  [STEP.TIMING]: TimingStep,
  [STEP.PAYMENT]: PaymentStep,
  [STEP.SUMMARY]: SummaryStep,
}

function Unbuilt({ step }) {
  return (
    <div className="border border-dashed border-hairline rounded-card px-4 py-8 text-center">
      <p className="text-body-s text-ink-3">Ginagawa pa ang hakbang na ito.</p>
      <p className="mt-1 text-label uppercase text-ink-3">{step}</p>
    </div>
  )
}

export default function StepBody({ step, partner, delivery }) {
  const Component = BODIES[step]

  return Component ? <Component partner={partner} delivery={delivery} /> : <Unbuilt step={step} />
}
